import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Message } from "primereact/message";

import { faShieldCheck } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { translationKeys } from "../../../../models/app-translation-keys";

import "./AiUsageWarning.scss";

import { useStore } from "../../../../stores/StoreContext";
import { TextMarkdown } from "../TextMarkdown/TextMarkdown";

export const AiUsageWarning: FunctionComponent<{ type: "aiUsageInfo" | "aiWarning" }> = ({ type }) => {
  const { t } = useTranslation();
  const { whitelabelStore } = useStore();

  if (type === "aiUsageInfo") {
    return (
      <div className="ai-info-container">
        <Message
          severity="info"
          text={t(translationKeys.aiUsageWarning.aiUsageInfo)}
          icon={<FontAwesomeIcon icon={faShieldCheck} className="ai-warning-icon" />}
          className="ai-warning-message"
        />
      </div>
    );
  }

  return (
    <TextMarkdown className="ai-warning">
      {t(translationKeys.aiUsageWarning.aiWarning, { chatBotName: whitelabelStore.chatBotName })}
    </TextMarkdown>
  );
};
